import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { TbMenu } from "react-icons/tb";
import logo from '../images/kaizek-logo.svg';

const Navbar = () => {
    const [onTap, setOnTap] = useState(false);
    
      const [nav, setNav] = useState(false)
      const handleNav = () => {
          setNav(!nav)
          setOnTap((prev) => !prev); 
        }

    const handleScroll = (event, sectionId) => {
        event.preventDefault(); // Prevent default anchor behavior
    
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      };

    return (
        <>
            <nav className='flex-wrap sm:fixed w-full top-0 left-0 z-50 mx-auto lg:my-2'>
                <div className='px-6 lg:mx-14 lg:px-8 2xl:px-12 py-8 lg:py-4 2xl:py-6 lg:rounded-3xl flex items-center justify-between bg-white/60 backdrop-blur-3xl'>
                    <div className='float-start'>
                    <Link to={"/"}><img src={logo} alt="Kaizek-logo"/></Link>
                    </div>
                    
                    <div className='hidden lg:flex justify-center'>
                        <ul className='hidden sm:inline-flex text-xl leading-8'>
                        {/* <Link to='/core-services'> */}
                        <li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'><a href="#services" onClick={(e) => handleScroll(e, "services")}>Services</a></li>
                        <li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'><a href="#capabilities" onClick={(e) => handleScroll(e, "capabilities")}>Capabilities</a></li>
                        <li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'><a href="#smartcity" onClick={(e) => handleScroll(e, "smartcity")}>Smart City</a></li>
                        <li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'><a href="#casestudies" onClick={(e) => handleScroll(e, "casestudies")}>Case Studies</a></li>
                        <li className='font-symbol text-lg lg:text-xl text-[var(--darkgray)] px-[10px] xl:px-4 2xl:px-5 py-2 rounded-full transition ease-in hover:font-extrabold hover:text-[var(--kaizenblue)]'><a href="#contact" onClick={(e) => handleScroll(e, "contact")}>Contact</a></li>            
                        </ul>
                    </div>
                    <div className='hidden xl:flex'>
                    <a href="#form" onClick={(e) => handleScroll(e, "form")}>
                        <button className="button-theme">
                        Start a project
                        </button>
                    </a>
                    </div>

                    <div onClick={handleNav} className='lg:hidden z-20'>
                    <TbMenu size={20} color={onTap ? '#342E6D' : '#342E6D'} />
                    </div>
                    <div
                    onClick={handleNav}
                    className={nav ? 'overflow-y-hidden z-10 lg:hidden ease-in duration-300 absolute text-[var(--kaizenblue)] left-0 top-0 w-full h-screen bg-[#F7F7F7] px-4 py-8 flex flex-col' : 'absolute top-0 h-screen left-[-100%] ease-in duration-500'}>

                    <div className='place-content-center flex'>
                    <img src={logo} alt="Kaizek logo"/>
                    </div>

                    <ul className='h-max w-full text-center py-8'>
                        <li className='font-symbol px-4 text-2xl py-4'><a href="#services" onClick={(e) => handleScroll(e, "services")}>Services</a></li>
                        <li className='font-symbol px-4 text-2xl py-4'><a href="#capabilities" onClick={(e) => handleScroll(e, "capabilities")}>Capabilities</a></li>
                        <li className='font-symbol px-4 text-2xl py-4'><a href="#smartcity" onClick={(e) => handleScroll(e, "smartcity")}>Smart City</a></li>
                        <li className='font-symbol px-4 text-2xl py-4'><a href="#casestudies" onClick={(e) => handleScroll(e, "casestudies")}>Case Studies</a></li>
                        <li className='font-symbol px-4 text-2xl py-4'><a href="#contact" onClick={(e) => handleScroll(e, "contact")}>Contact</a></li>
                    </ul>
                    <div className='place-content-center grid grid-flow-row gap-2 place-items-center my-2'>
                        <a href="#form" onClick={(e) => handleScroll(e, "form")}>
                            <button className="button-theme">
                            Start a project
                            </button>
                        </a>
                    </div>
                    </div>
                </div>
            </nav>
    {/* <h2 className='font-uiBold'>hello world</h2>
    <h2 className='font-uiSemilight'>hello world</h2>
    <h2 className='font-symbol'>hello world</h2> */}
        </>
    )
}

export default Navbar